import { gql } from "@apollo/client";

export const GET_ROLES = gql`
  query {
    getRoles {
      message
      statusCode
      response {
        rol_usuario_id
        valor
      }
    }
  }
`;
export const UPDATE_USER = gql`
  mutation updateUser(
    $usuario_id: Int
    $nombre: String
    $nombre_empresa: String
    $apellido: String
    $email: String
    $password: String
    $activo: Boolean
    $rol_usuario_id: Int
  ) {
    updateUser(
      usuario_id: $usuario_id
      nombre: $nombre
      nombre_empresa: $nombre_empresa
      apellido: $apellido
      email: $email
      password: $password
      activo: $activo
      rol_usuario_id: $rol_usuario_id
    ) {
      message
      statusCode
      error
      response
    }
  }
`;

export const UPDATE_USER_PASSWORD = gql`
  mutation UpdateUserPassword($email: String!, $password: String!) {
    updatePassword(email: $email, password: $password) {
      message
      statusCode
      response {
        usuario_id
        email
        nombre
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($usuario_id: Int!) {
    deleteUser(usuario_id: $usuario_id) {
      message
      statusCode
      error
      response
    }
  }
`;

export const REGISTER_USER = gql`
  mutation RegisterUser(
    $email: String!
    $password: String!
    $rol_usuario_id: Int!
    $nombre: String!
    $nombre_empresa: String!
    $apellido: String!
  ) {
    createUser(
      email: $email
      password: $password
      rol_usuario_id: $rol_usuario_id
      nombre_empresa: $nombre_empresa
      nombre: $nombre
      apellido: $apellido
    ) {
      message
      statusCode
      response {
        usuario_id
        email
        nombre
      }
    }
  }
`;
export const LOGOUT = gql`
  query {
    logout {
      message
      statusCode
    }
  }
`;
export const LOGIN_QUERY = gql`
  query Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      message
      statusCode
      response {
        usuario_id
        email
        nombre
        token
      }
    }
  }
`;

export const JWT_PASSWORD_CHECK = gql`
  query checkToken($token: String!) {
    validateToken(token: $token) {
      statusCode
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($token: String!, $password: String!) {
    recoverPassword(token: $token, password: $password) {
      statusCode
    }
  }
`;

export const RECOVER_PASSWORD = gql`
  mutation RecoverPassword($email: String!) {
    forgottenPass(email: $email) {
      statusCode
    }
  }
`;
